var map = {
	"./applab/skins": 2614,
	"./bounce/skins": 3087,
	"./craft/agent/skins": 3090,
	"./craft/code-connection/skins": 3091,
	"./craft/designer/skins": 3089,
	"./craft/simple/skins": 3088,
	"./flappy/skins": 3095,
	"./jigsaw/skins": 3107,
	"./maze/skins": 2268,
	"./netsim/skins": 3129,
	"./p5lab/skins": 2471,
	"./studio/skins": 3131,
	"./studio/starwars/skins": 2641,
	"./turtle/skins": 2699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5086;